import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { DocumentReportDto } from '@/modules/common/dto/document-report.dto.ts';
import type { DocumentReport } from '@/modules/document/adapters/document-report.type.ts';

export class DocumentReportAdapter {
  private static map(response: DocumentReportDto, forceDefault = false): DocumentReport {
    return {
      fileId: response.F_ID,
      name: response.Название.replace(/\.[^/.]+$/, ''),
      default: forceDefault || !!response['По умолчанию'],
    };
  }

  static mapList(response: ItemsDto<DocumentReportDto>) {
    const sortedResult = response.items.sort((a, b) => a.Название.localeCompare(b.Название));

    const isSomeDefault = sortedResult.some((r) => r['По умолчанию']);

    return sortedResult.map((r, index) => DocumentReportAdapter.map(r, !isSomeDefault && index === 0));
  }
}
